export default __webpack_public_path__ + "static/media/care_device_zoom_in.3ed4b977.svg";